<template>
  <v-row justify="center">
    <v-dialog v-model="dialog.show" persistent max-width="380">
      <v-card>
        <v-card-title id="dialog-store-title">
          <v-img
            class="modal-icon"
            max-width="32"
            src="../../assets/images/icons/icon-02.png"
          ></v-img>
          <span class="title white--text">{{ trans.title }}</span>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" fab outlined dark small @click="close">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text flat style="padding: 0 16px 0">
          <div v-if="state < 4">
            <v-stepper :value="state" alt-labels class="mt-4">
              <v-stepper-header>
                <v-stepper-step step="1" :complete="state > 1">{{
                  trans.step_1
                }}</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2" :complete="state > 2">{{
                  trans.step_2
                }}</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3" :complete="state > 3">{{
                  trans.step_3
                }}</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="4">{{ trans.step_4 }}</v-stepper-step>
              </v-stepper-header>
            </v-stepper>
          </div>
          <div v-if="state === 1">
            <v-form>
              <v-text-field
                solo
                :placeholder="trans.placeholder"
                maxlength="6"
                v-model="user"
                required
                v-mask="'######'"
              ></v-text-field>
            </v-form>
          </div>
          <div v-if="state === 2">
            <v-form>
              <v-text-field v-if="dialog.userType == 'DM'"
                solo
                :placeholder="trans.placeholder_dm"
                maxlength="20"
                v-model="dropoffCode"
                required
                v-mask="'XXXXXXXXXXXXXXXXXXXX'"
                :error-messages="errors"
              ></v-text-field>
              <v-text-field v-else
                solo
                :placeholder="trans.placeholder_jt"
                maxlength="10"
                v-model="phoneNo"
                required
                v-mask="'##########'"
                :error-messages="errors"
              ></v-text-field>
            </v-form>
          </div>
          <div v-if="state === 3">
            <v-container v-if="subState === 1 && reopen === 1">
              <v-row>
                <v-col align="center">
                  <h2 class="red--text">{{ trans.selected_locker }} {{ dropoffCode }}</h2>
                </v-col>
              </v-row>
              <v-row>
                <v-col align="right">
                  <h2>{{ trans.total }}</h2>
                </v-col>
                <v-col align="center">
                  <h2>{{ locker.totals }}</h2>
                </v-col>
                <v-col align="center">
                  <h2>{{ trans.locker }}</h2>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col align="center" class="pa-6">
                  <h2 class="red--text">{{ trans.selected_for_reopen }}</h2>
                </v-col>
              </v-row>
              <v-row align="center">
                <template v-for="n in locker.cells">
                  <v-col :key="n.cellno" cols="3" class="text-center">
                    <BtnLock
                      :btn="btn"
                      :lockerId="1"
                      :cellNo="n.cellno"
                      v-on:open="selectLocker(n)"
                    ></BtnLock>
                    <p class="pa-3 text-center">{{ trans.locker_no }} {{ n.cellno }}</p>
                  </v-col>
                </template>
              </v-row>
            </v-container>
            <v-container v-if="subState === 2">
              <v-row>
                <v-col align="center" class="pa-6">
                  <h2 class="red--text">{{ trans.select_locker }}</h2>
                </v-col>
              </v-row>
              <v-row align="center">
                <template v-for="n in sizes.cellssizes">
                  <v-col :key="n.cellno" cols="4" class="text-center">
                    <BtnCellSize
                      :btn="btn"
                      :lockerId="1"
                      :cellNo="n.cellno"
                      :size="n.size"
                      v-on:open="selectSize(n)"
                    ></BtnCellSize>
                    <p class="pa-3 text-center">{{ n.size }}</p>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </div>
          <div v-if="state === 4">
            <v-container style="padding: 32px">
              <div align="center">
                <v-icon size="64" color="green text-center"
                  >mdi-check-circle-outline</v-icon
                >
                <h2 class="success--text text-center" style="padding-top: 8px">
                  {{ trans.complete_modal }}
                </h2>
              </div>
            </v-container>
          </div>
        </v-card-text>
        <v-card-actions v-if="state === 1">
          <v-container>
            <v-row cols="10">
              <v-col class="sm-6">
                <v-btn outlined width="100%" @click="close">Cancel</v-btn>
              </v-col>
              <v-col class="sm-6">
                <v-btn
                  color="error"
                  width="100%"
                  @click="submitUser"
                  :disabled="user.length < 4"
                  >OK</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
        <v-card-actions v-if="state === 2">
          <v-container>
            <v-row cols="10">
              <v-col class="sm-6">
                <v-btn outlined width="100%" @click="back(1)"
                  >Back</v-btn
                >
              </v-col>
              <v-col class="sm-6">
                <template v-if="dialog.userType == 'DM'">
                  <v-btn
                    :disabled="dropoffCode.length < 4"
                    color="error"
                    width="100%"
                    @click="submitCheckDropoff"
                    >OK</v-btn
                  >
                </template>
                <template v-else>
                  <v-btn
                    :disabled="phoneNo.length < 10"
                    color="error"
                    width="100%"
                    @click="submitGetDropoff"
                    >OK</v-btn
                  >
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
        <v-card-actions v-if="state === 3">
          <v-container>
            <v-row no-gutters v-if="subState == 1">
              <v-col cols="12">
                <v-btn
                  block
                  color="orange"
                  class="ma-2 white--text"
                  @click="getLockerCellSize"
                >
                  <v-icon left>mdi-plus-circle-outline</v-icon>
                  {{ trans.open_more }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  block
                  color="green"
                  class="ma-2 white--text"
                  :disabled="selectedLocker == null"
                  @click="openLocker"
                >
                  <v-icon left>mdi-lock-open</v-icon>
                  {{ trans.reopen }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="subState == 2">
              <v-col cols="12">
                <v-btn
                  block
                  color="orange"
                  class="ma-2 white--text"
                  @click="getLockerCellSize"
                  :disabled="!addCellFlag"
                >
                  <v-icon left>mdi-plus-circle-outline</v-icon>
                  {{ trans.add_locker_btn }}
                </v-btn>
              </v-col>
              <v-col cols="5" :hidden="openning">
                <v-btn
                  block
                  color="green"
                  class="ma-2 white--text"
                  :disabled="selectedLocker == null"
                  @click="openLocker"
                >
                  {{ trans.open_locker_btn }}
                </v-btn>
              </v-col>
              <v-col cols="5" :hidden="!openning">
                <v-btn
                  block
                  outlined
                  class="ma-2"
                  :disabled="selectedLocker == null"
                  @click="cancelDropoff"
                >
                  {{ trans.cancel_btn }}
                </v-btn>
              </v-col>
              <v-col cols="5" offset="2">
                <v-btn
                  block
                  color="green"
                  class="ma-2 white--text"
                  @click="sendNotification"
                  :disabled="!completeDropFlag"
                >
                  {{ trans.done_btn }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mask } from "vue-the-mask";
import BtnLock from "../Button/BtnLock";
import BtnCellSize from "../Button/BtnCellSize";

export default {
  components: {
    BtnLock,
    BtnCellSize,
  },
  directives: { mask },
  props: {
    rules: Object,
    dialog: Object,
    locker: Object,
    sizes: Object,
    trans: Object,
  },
  data() {
    return {
      mask: "##########",
      openning: false,
      reopen: -1,
      state: 1,
      subState: 0,
      btn: {
        width: 64,
        height: 64,
      },
      user: "",
      dropoffCode: "",
      phoneNo: "",
      errors: "",
      totals: 0,
      selectedLocker: null,
      reopenDisabled: true,
      addCellFlag: false,
      completeDropFlag: false,
    };
  },
  mounted() {
    this.$root.$on("open cell", () => {
      this.openning = true;
    });
  },
  methods: {
    submitUser() {
      this.$emit("authen", this.user);
    },
    submitGetDropoff() {
      this.$emit("getDropoffCode", this.user, this.phoneNo);
    },
    submitCheckDropoff() {
      this.$emit("checkDropoffCode", this.user, this.dropoffCode);
    },
    openLocker() {
      this.$emit("openLocker", this.selectedLocker, "D");
    },
    cancelDropoff() {
      this.$emit(
        "cancelDropoff",
        this.selectedLocker,
        this.user,
        this.dropoffCode
      );
      this.selectedLocker = null;
    },
    getLockerCellSize() {
      this.$emit("getLockerCellSize", this.user, this.dropoffCode);
      this.selectedLocker = null;
    },
    sendNotification() {
      this.$emit("sendNotification", this.user, this.dropoffCode);
    },
    close() {
      let currentStep = this.dialog.step;
      if (currentStep != 4 || this.dialog.userType != 'DM') {
        this.user = "";
        this.dialog.userType = "";
      }
      this.phoneNo = "";
      this.dropoffCode = ""
      this.selectedLocker = null;
      this.dialog.reopen = -1;
      this.dialog.subStep = 0;
      this.dialog.step = 1;
      this.openning = false;
      this.$emit("close", currentStep);
    },
    selectLocker(n) {
      this.selectedLocker = n;
      this.$root.$emit("select", n.cellno);
      this.$root.$emit("unselect", n.cellno);
    },
    selectSize(n) {
      this.selectedLocker = n;
      this.$root.$emit("select", n.cellno);
      this.$root.$emit("unselect", n.cellno);
    },
    resetState() {
      this.openning = false;
      this.selectedLocker = null;
      this.$root.$emit("unselectAll");
    },
    async back(step) {
      this.$set(this.dialog, 'step', 1)
      await this.$nextTick()
      this.phoneNo = "";
      this.user = "";
    }
  },
  watch: {
    "dialog.step": function(newVal) {
      this.state = newVal;
    },
    "dialog.subStep": function(newVal) {
      this.subState = newVal;
    },
    "dialog.reopen": function(newVal) {
      this.reopen = newVal;
    },
    "dialog.reset": function(newVal) {
      if (newVal) {
        this.resetState();
        this.dialog.reset = false;
      }
    },
    "dialog.addcellflag": function(newVal) {
      this.addCellFlag = newVal == 1;
    },
    "dialog.completedropflag": function(newVal) {
      this.completeDropFlag = newVal == 1;
    },
  },
};
</script>
<style scoped>
.container {
  padding: 4px 12px 4px 12px;
}
span.title {
  font-family: "Roboto", "Kanit", sans-serif !important;
}
.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 75px !important;
}
.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px -20px 0;
}
.v-card__text {
  font-size: 0.8rem;
}
.col.col-3 {
  padding: 4px;
}
.v-application p {
  margin-bottom: 0;
}
.v-application .ma-2 {
  margin: 4px 0 8px 0 !important;
}
</style>
